<template>
  <div class="flex justify-center items-center" >
    <div v-if="!editMagazineValue" class="flex gap-2 justify-center text-center ">
      <div class="flex justify-center items-center gap-2">
        <span class="p-1">Name</span>
        <input v-model="name" :readonly="true" class="border border-trader-input-border   w-[150px] p-1 text-center shadow-inner-2">
      </div>
      <div class="flex justify-center items-center gap-2 ">
        <span class="p-1">Von</span>
        <input v-model="from" :readonly="true"  class="border border-trader-input-border p-1 w-[150px]  text-center shadow-inner-2">
      </div>
      <div class="flex justify-center items-center gap-2">
        <span class="p-1">Bis</span>
        <input v-model="to" :readonly="true"  class="border border-trader-input-border p-1 w-[150px] text-center shadow-inner-2">
      </div>
      <div class="flex justify-center items-center gap-2">
        <span class="p-1">Drucknummer</span>
        <input v-model="printNumber" :readonly="true"  class="border border-trader-input-border p-1 w-[150px] text-center shadow-inner-2">
      </div>
      <div class="flex justify-center items-center  gap-2">
        <i class="fa-solid fa-pencil ml-1 p-2 bg-trader-dark-gray hover:bg-trader-hover-background hover:text-trader-hover-text hover:cursor-pointer"
           title="bearbeiten" data-ui="edit-article-number" @click="changePageName"></i>
      </div>
    </div>

    <div v-else class="flex justify-center items-center gap-2">
      <div class="flex gap-2">
        <div class="flex justify-center items-center gap-2">
          <span class="p-1">Name</span>
          <input v-model="newName" class="border border-trader-input-border  w-[150px] p-1 text-center shadow-inner-2">
        </div>
        <div class="flex justify-center items-center gap-2 ">
          <span class="p-1">Von</span>
          <input v-model="newStartDate" type="date"
                 class="border border-trader-input-border p-1 w-[150px] text-center shadow-inner-2">
        </div>
        <div class="flex justify-center items-center gap-2">
          <span class="p-1">Bis</span>
          <input v-model="newEndDate" type="date"
                 class="border border-trader-input-border p-1 w-[150px] text-center shadow-inner-2">
        </div>
        <div class="flex justify-center items-center gap-2">
          <span class="p-1">Drucknummer</span>
          <input v-model="newPrintNumber" class="border border-trader-input-border  w-[150px] p-1 text-center shadow-inner-2">
        </div>
        <i class="fa-solid fa-check  p-2 bg-trader-green hover:bg-trader-hover-background hover:text-trader-hover-text text-trader-dark-green hover:cursor-pointer "
           title="speichern" data-ui="edit-article-number" @click="editMagazine()"></i>
        <i class="fa-solid fa-circle-xmark  p-2 bg-trader-red hover:bg-trader-hover-background text-trader-dark-red hover:text-trader-hover-text hover:cursor-pointer"
           title="abbrechen" @click="changePageName()" data-ui="save-article-number"></i>
      </div>
    </div>


  </div>
</template>

<script>

import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

export default {
  name: "CEditMagazine",
  data() {
    return {
      name: '',
      from: '',
      to: '',
      printNumber: '',
      editMagazineValue: false,
      newName: '',
      newStartDate: '',
      newEndDate: '',
      newPrintNumber: ''

    }
  },
  props: {
    magazineId: {
      type: Number,
      required: true
    },
  },
  methods: {

    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;

    },
    async editMagazine() {

      
      if (this.newStartDate == ''){
        this.newStartDate = this.from
      }else if (this.newEndDate == ''){
        this.newEndDate = this.to
      }

      const magazineData = {
        magazineId: this.magazineId,
        name: this.newName,
        from: this.newStartDate,
        to: this.newEndDate,
        printNumber: this.newPrintNumber
      };

      const mutation = gql`
        mutation editMagazine($magazine: MagazineInputValue!) {
           editMagazine(magazine: $magazine) {
            success
          }
        }
      `;

      try {
        const variables = {
          magazine: magazineData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        this.editMagazineValue = !this.editMagazineValue;
        this.name = this.newName
        this.from = this.newStartDate
        this.to = this.newEndDate;
        this.printNumber = this.newPrintNumber;
       await this.getMagazine();
      } catch (error) {
        console.error(error);

      }
    },
    async getMagazine() {
      try {
        const response = await apolloClient.query({
          query: gql`
        query getMagazine($magazineId: Int!) {
          getMagazine(magazineId: $magazineId) {
            name
            from
            to
            printNumber
          }
        }
      `,
          variables: {
            magazineId: this.magazineId  // Ensure this is the correct variable name
          }
        });
        this.name = response.data.getMagazine.name;
        this.newStartDate = this.formatTimestamp(response.data.getMagazine.from)
        this.newEndDate = this.formatTimestamp(response.data.getMagazine.to)
        this.from = this.formatTimestamp(response.data.getMagazine.from);
        this.to = this.formatTimestamp(response.data.getMagazine.to);
        this.printNumber = response.data.getMagazine.printNumber;
        this.newPrintNumber = response.data.getMagazine.printNumber;
      } catch (error) {
        console.error(error);
      }
    },
    changePageName() {
      this.newName = this.name
      this.editMagazineValue = !this.editMagazineValue;
    },
    formatDate(unixTimestamp) {
      const date = new Date(unixTimestamp * 1000); // Das Multiplizieren mit 1000 ist notwendig, da JavaScript Millisekunden erwartet.
      return date.toLocaleString(); // Dies gibt das Datum und die Uhrzeit in einem lokalisierten Format zurück.
    },
  },
  watch: {},
  mounted() {
    this.getMagazine();
  }
}
</script>